import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MediaService } from '../media.service';
import { ModelService } from '../../product/model.service';
import { MediaGridItem } from '../media-grid/media-grid.component';

@Component({
  selector: 'app-videos-page',
  templateUrl: './videos-page.component.html',
  styleUrls: ['./videos-page.component.css']
})
export class VideosPageComponent implements OnInit, OnDestroy {
  private mediaService = inject(MediaService);
  private modelService = inject(ModelService);
  private destroy$ = new Subject<void>();

  items: MediaGridItem[] = [];
  loading = true;
  private modelNames = new Map<string, string>();

  ngOnInit(): void {
    this.loadVideos();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadVideos(): void {
    this.loading = true;
    this.mediaService.getLatestVideos(24).pipe(takeUntil(this.destroy$)).subscribe({
      next: (videos) => {
        this.items = videos.map(vid => ({
          type: 'video' as const,
          data: vid,
          modelName: ''
        }));
        this.loading = false;
        this.resolveModelNames(videos.map(v => v.userId));
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  private resolveModelNames(userIds: string[]): void {
    const unique = [...new Set(userIds)];
    unique.forEach(uid => {
      if (this.modelNames.has(uid)) return;
      this.modelService.getModelById(uid).pipe(takeUntil(this.destroy$)).subscribe({
        next: (model) => {
          this.modelNames.set(uid, model.name);
          this.items = this.items.map(item =>
            item.data.userId === uid ? { ...item, modelName: model.name } : item
          );
        },
        error: () => {
          this.modelNames.set(uid, 'Unknown');
        }
      });
    });
  }
}
